import { create } from "../../../common/utils/zustand_state_manager";
import { IEntregaObrasRepository } from "../../../features/entregaObras/domain/repositories/entrega_obras_repositories";
import { EntregaObrasRepository } from "../../../features/entregaObras/data/repositories/entrega_obras_repositories";
import { useEntregaObrasServices } from "./use_services";

/**
 * useEntregaObrasRepositories
 */

type State = {
  entregaObrasRepository: IEntregaObrasRepository,
};

export const useEntregaObrasRepositories = create<State>((set, get) => {
  const { entregaObrasService } = useEntregaObrasServices.getState();
  return ({
    entregaObrasRepository: new EntregaObrasRepository(entregaObrasService),
  });

});